import { render, staticRenderFns } from "./LastAccessTime.vue?vue&type=template&id=70382070&"
import script from "./LastAccessTime.vue?vue&type=script&lang=js&"
export * from "./LastAccessTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports